import { WbLink, WbText } from '@workbench/react';

interface MailToButtonProps {
    mailto: string;
    label: string;
    text?: boolean;
    className?: string;
}

function MailToButton(props: Readonly<MailToButtonProps>) {
    return (
        <WbLink variant="inline" href={`mailto:${props.mailto}`} className={props.className}>
            {props.text ? <WbText>{props.label}</WbText> : <>{props.label}</>}
        </WbLink>
    );
}

export default MailToButton;
